// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import './assets/element-variables.scss'  // 引入自定义主题
import './assets/login.css';
import './assets/app.css';
import VueClipboard from 'vue-clipboard2'
import TagSelect from '@/components/TagSelect.vue';
import VCharts from 'v-charts-v2'

Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.use(VueClipboard )
Vue.use(VCharts);
Vue.component("tag-select", TagSelect)

Vue.config.productionTip = false
Vue.prototype.getMonthStart = function () {
  const today = new Date();
  const dayOfMonth = today.getDate();

  let targetDate;
  if (dayOfMonth > 7) {
    targetDate = new Date(today.getFullYear(), today.getMonth(), 1);
  } else {
    targetDate = new Date(today);
    targetDate.setDate(targetDate.getDate() - 30);
  }

  // 格式化成 YYYY-MM-DD
  const yyyy = targetDate.getFullYear();
  const mm = String(targetDate.getMonth() + 1).padStart(2, '0');
  const dd = String(targetDate.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js